module.exports = __webpack_public_path__ + "media/img/why/crm-e2393f5b5b9f8d8338bd013aa2dc25ab.png";